module.exports = __webpack_public_path__ + "img/installation-4.71e000c7.png";